import { render } from "./ProjectsOpen.vue?vue&type=template&id=a780928e"
import script from "./ProjectsOpen.vue?vue&type=script&lang=js"
export * from "./ProjectsOpen.vue?vue&type=script&lang=js"

import "./ProjectsOpen.vue?vue&type=style&index=0&id=a780928e&lang=css"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__